import { memo } from 'react';
import cn from 'classnames';
import { ITopTag } from 'src/interface';
import { Element, RouterLink as Link } from 'src/components';
import ContentTopTags from '../ContentTopTags';

interface IProps {
    publisher: any;
    originalUrl?: string;
    redirectUrl: string;
    tags?: ITopTag[];
}

export default memo(function ContentSource({
    publisher = {},
    redirectUrl,
    originalUrl,
    tags = [],
}: IProps) {
    if (!publisher || !originalUrl) {
        return null;
    }

    return (
        <Element
            className={cn(
                'article-source',
                'text-[1.4rem] leading-[18px]',
                'font-semibold',
                'ml-[-16px] px-[16px] py-[12px]',
                "w-[calc(100%+32px)]",
                "bg-[#f8f9fa]",
                "shadow-[0px_-1px_0px_rgba(0,0,0,0.05),0px_1px_0px_rgba(0,0,0,0.05)]"
            )}
        >
            <ContentTopTags tags={tags} />
            <Link
                className="font-semibold"
                to={redirectUrl || '/'}
                title="Xem bài gốc"
                newTab
            >
                <Element className={'text-[#333]'} renderAs="span">
                    Nguồn {publisher.shortName}:{' '}
                </Element>
                <Element className={cn('text-[#adb5bd]')} renderAs="span">
                    {originalUrl}
                </Element>
            </Link>
        </Element>
    );
});
